var app = angular.module("leonardo");

var DeleteTasksActions = function($scope, ngDialog, FilterService) {

  $scope.showDeleteDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/task/delete-tasks.html',
      controller: 'DeleteTasksDialog',
      data: {
        filters: {
          account: FilterService.getFilter('account_reports'),
          group: FilterService.getFilter('group_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          property: FilterService.getFilter('property_reports'),
          from_due_date: FilterService.getFilter('date_from'),
          to_due_date: FilterService.getFilter('date_to'),
          only_status_pending: FilterService.getFilter('only_status_pending'),
          include_workflow_and_unit_workflow_tasks: FilterService.getFilter('include_workflow_and_unit_workflow_tasks'),
          include_document_tasks: FilterService.getFilter('include_document_tasks'),
          include_personal_tasks: FilterService.getFilter('include_personal_tasks')
        }
      }
    });
  };

};

app.controller('DeleteTasksActions', ['$scope', 'ngDialog', 'FilterService', DeleteTasksActions]);
